import * as _ from 'lodash';
import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

const module = angular.module('progressive-status-info-section', []);

interface ProgressiveStatusInfoSectionController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    title: string;
    description: string;
    smartHomeDiscount: number;
    policyNumber: string;
    effectStart: string;
    effectEnd: string;
    hasBoughtProgressive: boolean;
    getQuoteUrl: string;
    getQuote: () => void;
}

module.component('progressiveStatusInfoSection', {
    template: template,
    bindings: {
        policyInfo: '<',
        smartHomeDiscount: '<'
    },
    controller: function(this: ProgressiveStatusInfoSectionController) {
        this.$onInit = () => {
            this.hasBoughtProgressive = _.get(this.policyInfo, 'auto_insurance_partner.status') === 'confirmed';
            this.title = this.hasBoughtProgressive
                ? 'Your auto insurance with Progressive'
                : 'Start your hassle-free auto quote';
            this.description = this.hasBoughtProgressive
                ? `Your car is covered with Progressive. 
                    If you have any questions, need to make a change or need to file a claim, please contact a Progressive representative at 
                    <hippo-number class="claim-number ng-isolate-scope" type="claims"><a href="tel:1-800-876-5581" class="claim-number">(800) 876-5581</a></hippo-number>`
                : 'We streamlined things so you can keep going with a similar time-saving and hasle-free experience to purchase auto insurance with ' +
                  '<strong>Drive</strong>, part of the <strong>progressive</strong> Group companies';

            this.policyNumber = _.get(this.policyInfo, 'auto_insurance_partner.policy_details.policy_number');
            this.effectStart = _.get(this.policyInfo, 'auto_insurance_partner.policy_details.effective_date_start');
            this.effectEnd = _.get(this.policyInfo, 'auto_insurance_partner.policy_details.effective_date_end');
            this.getQuoteUrl = _.get(this.policyInfo, 'auto_insurance_partner.partner_url');
        };
    }
});

export { module };
